/**
 * Money is always an integer number of grosze. Never a float.
 * 12000 === 120,00 zł
 *
 * `0.1 + 0.2 !== 0.3`, and you do not want to find that out on an invoice.
 */
/** 120 -> 12000 */
export function zlotyToGrosz(zloty) {
    return Math.round(zloty * 100);
}
/** 12000 -> 120 */
export function groszToZloty(grosz) {
    return grosz / 100;
}
/**
 * Format for display. Whole amounts drop the decimals, because "120 zł"
 * reads better on a price card than "120,00 zł".
 *
 *   formatPrice(12000)  -> "120 zł"
 *   formatPrice(12550)  -> "125,50 zł"
 */
export function formatPrice(grosz, locale = 'pl-PL') {
    const hasFraction = grosz % 100 !== 0;
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'PLN',
        minimumFractionDigits: hasFraction ? 2 : 0,
        maximumFractionDigits: hasFraction ? 2 : 0,
    }).format(groszToZloty(grosz));
}
/** Price per hour, for offers whose duration isn't 60 minutes. */
export function pricePerHour(grosz, durationMin) {
    if (durationMin <= 0)
        return 0;
    return Math.round((grosz / durationMin) * 60);
}
